import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconLink = createIcon({
  displayName: 'IconLink',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M12 13V15H16V4H2V15H6V13H4V6H14V13H12ZM8 20H22V9H18V11H20V18H10V11H12V9H8V20Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
